export const surveyQuestion = (state = {}, action) => {
  switch (action.type) {
    case "SET_SURVEY_QUE":
      return action.data;
    case "FETCHING_SURVEY_QUESTION":
      return action.data;
    default:
      return state;
  }
};
